import React from "react";
import AdminLayout from "@/components/AdminLayout";
import CmsResource from "@/components/CmsResource";

const fields = [
  { name: "title", label: "Título", type: "text", wide: true },
  { name: "slug", label: "Slug", type: "text" },
  { name: "category", label: "Categoria", type: "select", options: ["Comprar", "Vender", "Zonas", "Mercado", "Guia"] },
  { name: "author", label: "Autor", type: "text" },
  { name: "date", label: "Data (ISO)", type: "text", placeholder: "2026-02-15T10:00:00Z" },
  { name: "summary", label: "Resumo", type: "textarea", wide: true, rows: 2 },
  { name: "main_image", label: "Imagem principal", type: "image", wide: true },
  { name: "content", label: "Conteúdo (Markdown simples: ## título, ### sub, - lista)", type: "textarea", wide: true, rows: 12 },
  { name: "seo_title", label: "SEO Title", type: "text", wide: true },
  { name: "meta_description", label: "Meta description", type: "textarea", wide: true, rows: 2 },
  { name: "published", label: "Publicado?", type: "checkbox", checkboxLabel: "Publicado" },
];

const defaults = {
  title: "", slug: "", category: "Comprar", author: "Zélia Silva",
  date: new Date().toISOString(), summary: "", main_image: "", content: "",
  seo_title: "", meta_description: "", published: true,
};

export default function AdminBlog() {
  return (
    <AdminLayout>
      <CmsResource
        resource="blog"
        title="Blog"
        singular="Artigo"
        fields={fields}
        defaults={defaults}
        displayColumns={[
          { key: "title", label: "Título" },
          { key: "category", label: "Categoria" },
          { key: "date", label: "Data", render: (r) => r.date ? new Date(r.date).toLocaleDateString("pt-PT") : "—" },
          { key: "published", label: "Estado", render: (r) => r.published ? "Publicado" : "Rascunho" },
        ]}
      />
    </AdminLayout>
  );
}
